class SwymTemplateListener extends HTMLElement {
  constructor() {
    super()

    this.showEmptyMessage = false
    this.indexInitialized = false
    this.singleViewInitialized = false
    this.options = { childList: true, subtree: true }
    this.emptyElement = this.querySelector('.no-wishlist-items')
    this.renderContainer = this.querySelector('#swym-wishlist-render-container')

    this.setView.bind(this)

    this.init()
  }

  init() {
    const self = this
    const isLoaded = (mutationList, observer) => {
      mutationList.forEach(() => {
        const indexNode = self.querySelector('.swym-wishlist-list')
        const singleNode = self.querySelector('.swym-wishlist-detail')

        self.singleViewInitialized = false
        self.indexInitialized = false

        if (indexNode) { // Index view
          if (!self.indexInitialized) {
            self.indexInitialized = true
            self.singleViewInitialized = false
            self.emptySwymElement = self.querySelector('.swym-empty-wishlist-container')

            if (self.emptySwymElement) {
              self.showEmptyMessage = true
            }

            self.setView()
          }
        } else if (singleNode) { // Single wishlist view
          if (!self.singleViewInitialized) {
            self.showEmptyMessage = false
            self.indexInitialized = false
            self.singleViewInitialized = true
            self.setView()
          }
        }
      })
    }
    const isReady = new MutationObserver(isLoaded)

    isReady.observe(this.renderContainer, this.options)
  }

  setView() {
    this.showEmptyMessage
      ? this.emptyElement.classList.remove('visually-hidden')
      : this.emptyElement.classList.add('visually-hidden')

    if (this.singleViewInitialized) {
      this.updateTitle()
      this.addToCartActions()
    }
  }

  updateTitle() {
    const title = this.querySelector('.swym-selected-wishlist-name')
    if (title) {
      const titleUpdate = title.textContent.split(' (')[0]
      const displayTitle = this.querySelectorAll('.swym-wishlist-main-title')
      displayTitle.forEach((updateTitle) => {
        updateTitle.textContent = titleUpdate
      })
    }
  }

  addToCartActions() {
    const addToCartButtons = this.querySelectorAll('.swym-add-to-cart-btn')
    addToCartButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          window.history.replaceState({}, document.title, "?addedtocart")
          window.location.reload()
        }, 500)
      })
    })
  }
}

customElements.define('swym-template-listener', SwymTemplateListener)


// Wishlist modal listener
const modalUpdate = (mutationList, observer) => {
  mutationList.forEach((mutation) => {
    const { addedNodes } = mutation

    addedNodes.forEach((node) => {
      if (node && node.classList && node.classList.contains('swym-product-title')) {
        const title = document.querySelector('.swym-product-title')

        if (title) {
          let newTitle = ""
          const currentTitle = title.querySelector('h3').innerHTML

          if (currentTitle.includes('-') && !currentTitle.includes('<br>')) {
            const newH3 = document.createElement("h3")

            newTitle = currentTitle.split(' - ')
            newTitle[1] = ``
            
            // const selectedItem = document.querySelector(".add2Cart_wishlist_wrapper .select-items .same-as-selected");
            // if (selectedItem) {
            //     newTitle[1] = selectedItem.innerHTML;
            // }

            newTitle = newTitle.join('<br>')

            newH3.setAttribute("class", "swym-product-name swym-product-name-new swym-heading swym-heading-1")
            newH3.innerHTML = newTitle
            title.insertAdjacentElement("beforeend", newH3)
          }
        }
      }
    })
  })
}

const modalListener = () => {
  const modalPopulate = new MutationObserver(modalUpdate)
  modalPopulate.observe(document.body, { childList: true, subtree: true })
}
modalListener()
